// ak-config/akd-config.js
export const akdConfig = {
  prod: {
    ak: [
      0x40, 0xab, 0x79, 0xfd, 0x27, 0x26, 0x09, 0x44, 0xca, 0xb6, 0x6b, 0x0f, 0xe6, 0x61, 0xe5,
      0x93, 0xb7, 0x1f, 0x4a, 0x8f, 0xe7, 0x0e, 0x2b, 0x12, 0x87, 0x85, 0x35, 0x85, 0xf8, 0xaa,
      0xfd, 0xb5, 0xb1, 0xe9, 0x5d, 0xf1, 0x12, 0xaf, 0x13, 0x8c, 0x6e, 0x77, 0xb1, 0x47, 0x99,
      0x57, 0x5c, 0x06, 0x3b, 0x46, 0x5a, 0xc6, 0x9b, 0x4c, 0x2a, 0x39, 0x12, 0x2b, 0x75, 0x91
    ],
    zeekrSignKey: [
      0xa1, 0x23, 0x26, 0xdb, 0x49, 0x3b, 0xf9, 0xb0, 0x1a, 0xf8, 0x61, 0xb2, 0x19, 0x8e, 0x6b,
      0x40, 0x5d, 0x79, 0xb7, 0x36, 0x3a, 0x84, 0xed, 0x08, 0x2b, 0x5e, 0x44, 0xca, 0x1d, 0xf9,
      0xe2, 0x88, 0xbf, 0x88, 0x85, 0xce, 0x63, 0x72, 0x06, 0x01, 0xa7, 0xb3, 0xb8, 0x10
    ],
    mdKey: [
      0x9a, 0xea, 0x5a, 0x0e, 0xf0, 0x51, 0x7b, 0x11, 0x6a, 0x8b, 0x39, 0x55, 0x22, 0xc8, 0x61,
      0x08, 0x79, 0x1d, 0x8c, 0x4d, 0xab, 0xbb, 0xd9, 0xb7, 0xa1, 0x08, 0xf1, 0x94, 0x4a, 0x96,
      0x9f, 0x13, 0xa5, 0xa4, 0xe4, 0x75, 0x2d, 0xfa, 0x71, 0xa5, 0x76, 0xe0, 0x1e, 0x58, 0xbf,
      0xa3, 0x13, 0x4a
    ],
    monitor: [
      0xfb, 0x33, 0x79, 0x3a, 0x0c, 0x60, 0x8e, 0x03, 0x39, 0x02, 0xe7, 0xb7, 0x82, 0x1c, 0x27,
      0x0a, 0xec, 0x4a, 0x28, 0xd9, 0xc3, 0x34, 0xb3, 0x2a, 0xb1, 0x96, 0xa7, 0x39, 0xc3, 0xfb,
      0xb6, 0xfa, 0x7e, 0x45, 0x1a, 0x20, 0xa8, 0x97, 0x02, 0xde, 0x31, 0x13, 0x32, 0xa7, 0x35,
      0xde, 0xbb, 0x4a, 0x4d, 0x68, 0xa6, 0x8a
    ]
  }
}
